import React from "react";
import { useNavigate } from "react-router-dom";
import { StudyBuddyWorkspace } from "./StudyBuddyPage";
import { studyBuddyPracticeUrl } from "./studyBuddyPracticeSelection";
import useStudyBuddyIframeHeight from "./useStudyBuddyIframeHeight";

export default function StudyBuddyEmbedPage() {
  const navigate=useNavigate();
  const heightRef=useStudyBuddyIframeHeight();
  return <div ref={heightRef}><StudyBuddyWorkspace embed onPracticeNavigate={(reference)=>navigate(studyBuddyPracticeUrl("/study-buddy-practice-v2-embed",reference),{state:{practice:reference}})} /></div>;
}
